module.exports = __webpack_public_path__ + "img/black-queen.1f45abc8.svg";